import Axios from "axios";
import { AUTH_CREDENTIALS_NAME, APIURL } from "./../Constantes";
import { putExtraCatalogo, putExtraPaquetePrecio } from "../services/serviceExtra";

const getCabecera = () => {
  let Token = localStorage.getItem(AUTH_CREDENTIALS_NAME);
  let cabecera = {
    Authorization: `bearer ${Token}`,
    "Content-Type": "application/json",
    Accept: "application/json",
  }
  return cabecera;
}

const urlDuck = "Addon";

const dataInicial = {
  array: [],
  exito: 0,
  objeto: {},
};

const GET_EXTRAS_ALL = "GET_EXTRAS_ALL";
const GET_EXTRAS_BY_PAQUETE = "GET_EXTRAS_BY_PAQUETE";
const GET_EXTRAS_CLEAR_STATE = "GET_EXTRAS_CLEAR_STATE";
const POST_ALTA_EXTRA = "POST_ALTA_EXTRA";
const PUT_ACTULIZA_EXTRA = "PUT_ACTULIZA_EXTRA"
const PUT_ACTULIZA_EXTRA_PRECIO = "PUT_ACTULIZA_EXTRA_PRECIO"
const DELETE_EXTRAS_PAQUETE = "DELETE_EXTRAS_PAQUETE";

export default function extrasReducer(state = dataInicial, action) {
  switch (action.type) {
    case PUT_ACTULIZA_EXTRA_PRECIO:
      return { ...state, exito: action.payload.exito };
    case DELETE_EXTRAS_PAQUETE:
      return { ...state, exito: action.payload.exito };
    case POST_ALTA_EXTRA:
      return { ...state, exito: action.payload.exito };
    case PUT_ACTULIZA_EXTRA:
      return { ...state, exito: action.payload.exito };
    case GET_EXTRAS_ALL:
      return { ...state, array: action.payload.array };
    case GET_EXTRAS_BY_PAQUETE:
      return { ...state, array: action.payload.array };
    case GET_EXTRAS_CLEAR_STATE:
      return { ...state, array: action.payload.array, exito: action.payload.exito, objeto: action.payload.objeto }
    default:
      return state;
  }
}

//* Metodos para manejo de extras 
export const eliminarExtraPaqueteAction = (idPaquete, idExtra) => async (dispatch) => {
  try {
    const respuesta = await Axios.delete(`${APIURL}/${urlDuck}/Package/${idPaquete}/${idExtra}`,
      {
        headers: getCabecera()
      });
    dispatch({
      type: DELETE_EXTRAS_PAQUETE,
      payload: {
        exito: 1
      }
    })
    return respuesta;
  } catch (error) {
    return error;
  }
};
export const altaExtraAction = (payload) => async (dispatch) => {
  try {
    const respuesta = await Axios.post(`${APIURL}/${urlDuck}/Add`, payload,
      {
        headers: getCabecera()
      });
    dispatch({
      type: POST_ALTA_EXTRA,
      payload: {
        exito: 1
      }
    })
    return respuesta;
  } catch (error) {
    return error;
  }
};
export const actulizaExtraAction = ({ IdExtra, Nombre, Descripcion }) => async (dispatch) => {
  return putExtraCatalogo({ IdExtra, Nombre, Descripcion }).then(Response => {
    dispatch({
      type: PUT_ACTULIZA_EXTRA,
      payload: {
        exito: 1
      }
    })
    return Response
  }).catch(Error => {
    return Error
  })
};
export const actulizaExtraPrecioAction = ({ IdExtra, IdPaquete, Precio, Descripcion }) => async (dispatch) => {
  return putExtraPaquetePrecio({ IdExtra, IdPaquete, Precio, Descripcion }).then(Response => {
    dispatch({
      type: PUT_ACTULIZA_EXTRA_PRECIO,
      payload: {
        exito: 1
      }
    })
    return Response
  }).catch(Error => {
    return Error
  })
};
export const obtenerExtrasByIdPaqueteAction = (IdPaquete) => async (dispatch) => {
  try {
    const respuesta = await Axios.get(`${APIURL}/${urlDuck}/Package/${IdPaquete}`,
      {
        headers: getCabecera()
      });
    dispatch({
      type: GET_EXTRAS_BY_PAQUETE,
      payload: {
        array: respuesta.data
      }
    })
    return respuesta;
  } catch (error) {
    return error;
  }
};
export const clearExtrasState = () => async (dispatch) => {
  dispatch({
    type: GET_EXTRAS_CLEAR_STATE,
    payload: {
      array: [],
      exito: 0,
      objeto: {}
    }
  })
}
